import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import ImageUploading from "react-images-uploading";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdownDynamic from "../../components-react/SelectDropdownDynamic";
import CustomizedDropzon from "../../components-react/CustomizedDropzon";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import SelectDropdown from "../../components-react/SelectDropdown";
import {
  testimonialCategories,
  testimonialMediaType,
} from "../../common-data/DropdowData";
import { validateTestimonialForm } from "../Validations";
import { uploadImage } from "../../../redux/reducers/postApiSlice";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { addTestimonial, updateTestimonial } from "../../../data/ApiEndpoints";
import {
  extractFramesFromVideo,
  saveFrameAsFile,
} from "../../common-data/Conversions";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import Loader from "../../ui/Loader";

const TestimonialForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { postPutLoading } = useSelector((state) => state.common);
  const { loading } = useSelector((state) => state.postApi);

  const forminitials = [
    {
      userName: isEdit && rowData?.user_name ? rowData.user_name : "",
      selCategory:
        isEdit && rowData?.category
          ? {
              label: rowData?.category,
              value: rowData?.category,
            }
          : "",
      selGym:
        isEdit && rowData?.gym_id && rowData?.gym_name
          ? {
              label: rowData?.gym_name,
              value: rowData?.gym_id,
            }
          : "",
      rating: isEdit && rowData?.rating ? rowData.rating : "",
      selType:
        isEdit && rowData?.type
          ? {
              label: rowData?.type,
              value: rowData?.type,
            }
          : "",
      imageUrl: isEdit && rowData?.type === "image" ? rowData.media : "",
      videoUrl: isEdit && rowData?.type === "video" ? rowData.media : "",
      thumbnailUrl: isEdit && rowData?.thumbnail ? rowData.thumbnail : "",
      description:
        isEdit && rowData?.media_subtitle ? rowData.media_subtitle : "",
      isActive: isEdit ? (rowData?.status === "active" ? true : false) : false,
    },
  ];
  const [formValues, setFormValues] = useState(forminitials);
  const imgVdoInitials = [
    {
      image: isEdit && rowData?.media ? [{ data_url: rowData.media }] : [],
      video: [],
      frames: [],
      thumbnail: null,
      thumbnailFiledata: null,
    },
  ];
  const [formImages, setFormImages] = useState(imgVdoInitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const iniValues = {
    page: 1,
    search: "",
  };
  const [fetchValues, setFetchValues] = useState(iniValues);
  const [totalPages, setTotalPages] = useState(1);

  const onChangeInput = (e, index) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prevValues) => {
      const newValues = [...prevValues];
      if (type === "checkbox") {
        newValues[index][name] = checked;
      } else {
        newValues[index][name] = value;
      }
      return newValues;
    });
  };

  const onChangeDropdown = (selectedValue, name, index) => {
    if (name === "selCategory" && selectedValue?.value === "testimonial") {
      setFormValues((prevValues) => {
        const newValues = [...prevValues];
        newValues[index][name] = selectedValue;
        newValues[index].selType = {
          value: "video",
          label: "Video",
        };
        return newValues;
      });
    } else if (name === "selType") {
      setFormValues((prevValues) => {
        const newValues = [...prevValues];
        newValues[index][name] = selectedValue;
        newValues[index].thumbnailUrl = "";
        return newValues;
      });
      setFormImages((prevImages) => {
        const newImages = [...prevImages];
        newImages[index].image = [];
        newImages[index].video = [];
        newImages[index].frames = [];
        newImages[index].thumbnail = null;
        newImages[index].thumbnailFiledata = null;
        return newImages;
      });
    } else {
      setFormValues((prevValues) => {
        const newValues = [...prevValues];
        newValues[index][name] = selectedValue;
        return newValues;
      });
    }
  };

  const onChangeImages = (imageList, name, index) => {
    setIsSubmit(false);

    setFormImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index][name] = imageList;
      return newImages;
    });

    if (imageList.length > 0) {
      imageList.forEach(async (image) => {
        const blob = await fetch(image?.data_url).then((res) => res.blob());
        const file = new File([blob], "filename.jpeg", { type: "image/jpeg" });

        handleUploadImage(file, userInfoData?.token, index, "imageUrl");
      });
    }
  };

  const handleUploadImage = async (file, TOKEN, index, field) => {
    setIsSubmit(false);

    try {
      const actionResult = await dispatch(uploadImage({ file, TOKEN }));
      const result = actionResult.payload;

      if (result?.status) {
        setFormValues((prevValues) => {
          const newValues = [...prevValues];
          newValues[index][field] = result.image_url || "";
          return newValues;
        });

        if (field === "videoUrl" && file) {
          try {
            const frames = await extractFramesFromVideo(file);

            if (frames.length > 0) {
              setFormImages((prevImages) => {
                const newImages = [...prevImages];
                newImages[index].frames = frames;
                return newImages;
              });
            } else {
              console.warn("No frames extracted");
            }
          } catch (error) {
            console.error("Error extracting frames: ", error);
          }
        }

        toast.success(result?.message || "Success!");
      } else {
        const errorMessage = result?.message || "Something Went Wrong!";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("handleUploadImage ERROR => ", error);
    }
  };

  const handleVideoDrop = async (acceptedFiles, index) => {
    setIsSubmit(false);

    setFormImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index].video = [...newImages[index].video, ...acceptedFiles];
      return newImages;
    });

    if (acceptedFiles.length > 0) {
      acceptedFiles.forEach(async (video) => {
        handleUploadImage(video, userInfoData?.token, index, "videoUrl");
      });
    }
  };

  const handleThumbnailSelect = async (frame, index) => {
    const file = saveFrameAsFile(frame);

    setFormImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index].thumbnail = frame;
      newImages[index].thumbnailFiledata = file;
      return newImages;
    });

    await handleUploadImage(file, userInfoData?.token, index, "thumbnailUrl");

    // setFormImages((prevImages) => {
    //   const newImages = [...prevImages];
    //   newImages[index].thumbnail = frame;
    //   newImages[index].thumbnailFiledata = saveFrameAsFile(frame);
    //   return newImages;
    // });
  };

  const addForm = () => {
    setFormValues((prevValues) => [
      ...prevValues,
      {
        userName: "",
        selType: "",
        selCategory: "",
        selGym: "",
        rating: "",
        imageUrl: "",
        videoUrl: "",
        isActive: false,
      },
    ]);
    setFormImages((prevImages) => [
      ...prevImages,
      {
        image: [],
        video: [],
      },
    ]);
  };

  const removeForm = (index) => {
    setFormValues((prevValues) => prevValues.filter((_, i) => i !== index));
    setFormImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const onSubmit = () => {
    setFormErrors(validateTestimonialForm(formValues, formImages, isEdit));
    setIsSubmit(true);
  };

  const handleAdd = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? updateTestimonial : addTestimonial;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  // ********-------------
  const handleSearchChange = (inputValue) => {
    setFetchValues((prev) => ({
      ...prev,
      page: 1,
      search: inputValue,
    }));
  };

  const fetchMoreData = () => {
    if (fetchValues.page + 1 <= totalPages) {
      setFetchValues((prev) => ({
        ...prev,
        page: prev.page + 1,
      }));
    }
  };

  const fetchPreviousData = () => {
    setFetchValues((prev) => ({
      ...prev,
      page: Math.max(prev.page - 1, 1),
    }));
  };
  // ------------------**********

  useEffect(() => {
    dispatch(
      fetchGymData(
        userInfoData?.token,
        fetchValues.page,
        10,
        fetchValues.search || ""
      )
    );
  }, [fetchValues]);

  useEffect(() => {
    const totalGymPages = gymData?.[0]?.pagination?.[0]?.pages;
    setTotalPages(totalGymPages);
  }, []);

  useEffect(() => {
    const updatedImages = formImages.map((image) => {
      if (image.video.length === 0) {
        return {
          ...image,
          frames: [],
          thumbnail: null,
          thumbnailFiledata: null,
        };
      }
      return image;
    });

    // Only update state if there is a change
    if (JSON.stringify(formImages) !== JSON.stringify(updatedImages)) {
      setFormImages(updatedImages);
    }
  }, [formImages]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors).length === 0) {
      const formattedData = {
        bulk_vibe_data: formValues.map((vibe, index) => ({
          uid: isEdit && rowData?.uid ? rowData.uid : "",
          gym_id: vibe.selGym?.value || "",
          type: vibe.selType?.value || "",
          category: vibe.selCategory?.value || "",
          user_name: vibe.userName || "",
          rating: vibe.rating || "",
          media:
            vibe.selType?.value === "video"
              ? vibe.videoUrl || formImages[index].video[0]?.data_url || ""
              : vibe.selType?.value === "image"
              ? vibe.imageUrl || formImages[index].image[0]?.data_url || ""
              : "",
          thumbnail:
            vibe.selType?.value === "video" && vibe.thumbnailUrl
              ? vibe.thumbnailUrl
              : "",
          media_subtitle: vibe.description || "",
          status: vibe.isActive ? "active" : "inactive",
        })),
      };

      const formattedDataUpdate = {
        uid: isEdit && rowData?.uid ? rowData.uid : "",
        gym_id: formValues[0].selGym?.value || "",
        type: formValues[0].selType?.value || "",
        category: formValues[0].selCategory?.value || "",
        user_name: formValues[0].userName || "",
        rating: formValues[0].rating || "",
        media:
          formValues[0].selType?.value === "video"
            ? formValues[0].videoUrl || formImages[0].video[0]?.data_url || ""
            : formValues[0].selType?.value === "image"
            ? formValues[0].imageUrl || formImages[0].image[0]?.data_url || ""
            : "",
        thumbnail:
          formValues[0].selType?.value === "video" && formValues[0].thumbnailUrl
            ? formValues[0].thumbnailUrl
            : "",
        media_subtitle: formValues[0].description || "",
        status: formValues[0].isActive ? "active" : "inactive",
      };

      // if (isEdit) {
      //   handleAdd(formattedDataUpdate);
      // } else {
      //   handleAdd(formattedData);
      // }

      const handleConfirm = async () => {
        handleAdd(isEdit ? formattedDataUpdate : formattedData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        `${isEdit ? "Update" : "Add"}`
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formErrors=> ", formErrors);

  return (
    <div className="createNewCTOModalContainer mealsModalContainer addMealModal">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add New"}`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading || loading}
      />
      <form className="formContainer">
        {formValues.map((formInput, index) => (
          <React.Fragment key={index}>
            <div className="formInputsGrid twoGridSystem">
              <div className="formInputBox">
                <label htmlFor="rating" className={`formInputLabel `}>
                  Category <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors?.fieldErrors?.[index]?.selCategory
                      ? "formError"
                      : ""
                  }`}
                >
                  <SelectDropdown
                    options={testimonialCategories}
                    selectedOption={formInput.selCategory}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selCategory", index)
                    }
                    name="from the list"
                    preventKeyboardOpen={false}
                  />
                </div>
              </div>

              <div className="formInputBox">
                <label htmlFor="selGym" className="formInputLabel">
                  gym <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors?.fieldErrors?.[index]?.selGym ? "formError" : ""
                  }`}
                >
                  <SelectDropdownDynamic
                    options={gymData || []}
                    selectedOption={formInput.selGym}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selGym", index)
                    }
                    name="from the list"
                    preventKeyboardOpen={false}
                    onSearchChange={handleSearchChange}
                    fetchMoreData={fetchMoreData}
                    fetchPreviousData={fetchPreviousData}
                  />
                </div>
              </div>

              {formInput.selCategory?.value === "testimonial" ? (
                <>
                  <div className="formInputBox">
                    <label htmlFor="userName" className={`formInputLabel `}>
                      User Name <span className="required">*</span>
                    </label>

                    <input
                      type="text"
                      placeholder="Enter user name"
                      className={`formInput ${
                        formErrors?.fieldErrors?.[index]?.userName
                          ? "formError"
                          : ""
                      }`}
                      name="userName"
                      value={formInput.userName}
                      onChange={(e) => onChangeInput(e, index)}
                    />
                  </div>

                  <div className="formInputBox">
                    <label htmlFor="rating" className={`formInputLabel `}>
                      Rating (0 - 5) <span className="required">*</span>
                    </label>

                    <input
                      type="number"
                      placeholder="Enter user name"
                      className={`formInput ${
                        formErrors?.fieldErrors?.[index]?.rating
                          ? "formError"
                          : ""
                      }`}
                      name="rating"
                      value={formInput.rating}
                      onChange={(e) => onChangeInput(e, index)}
                      min={0}
                      max={5}
                    />
                  </div>
                </>
              ) : null}

              <div className="formInputBox">
                <label htmlFor="selType" className={`formInputLabel `}>
                  Media Type <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors?.fieldErrors?.[index]?.selType ? "formError" : ""
                  }`}
                >
                  <SelectDropdown
                    options={testimonialMediaType}
                    selectedOption={formInput.selType}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selType", index)
                    }
                    name="from the list"
                    preventKeyboardOpen={false}
                    isDisable={formInput.selCategory?.value === "testimonial"}
                  />
                </div>
              </div>
            </div>

            <div
              className={`formInputsGrid uploadsInputGrids`}
              style={{
                minHeight: !formInput.selType?.value ? "auto" : "200px",
              }}
            >
              {formInput.selType?.value === "image" ? (
                <div className="formInputBox formInputUploadBox">
                  <label htmlFor="image" className="formInputLabel">
                    Image <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper commonUploadWrapper no-border`}
                    style={{ height: "auto" }}
                  >
                    <div
                      className={`icon-upload-btn createIncentiveCategoryForImageUpload ${
                        formErrors.fieldErrors?.[index]?.image
                          ? "formError"
                          : ""
                      }`}
                    >
                      <div className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="49"
                          height="49"
                          viewBox="0 0 49 49"
                          fill="none"
                        >
                          <path
                            d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                            fill="#A5A5A5"
                          />
                          <path
                            d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="image">
                        {loading ? (
                          <Loader />
                        ) : (
                          <ImageUploading
                            multiple
                            value={formImages[index].image}
                            onChange={(imageList, addUpdateIndex) =>
                              onChangeImages(imageList, "image", index)
                            }
                            maxNumber={1}
                            dataURLKey="data_url"
                          >
                            {({
                              imageList,
                              onImageUpload,
                              onImageRemoveAll,
                              onImageUpdate,
                              onImageRemove,
                              isDragging,
                              dragProps,
                            }) => (
                              <div className="upload__image-wrapper">
                                {formImages[index].image?.length === 0 ? (
                                  <>
                                    <button
                                      type="button"
                                      style={
                                        isDragging
                                          ? { color: "red" }
                                          : undefined
                                      }
                                      onClick={onImageUpload}
                                      {...dragProps}
                                    >
                                      Upload
                                    </button>
                                    &nbsp;
                                  </>
                                ) : (
                                  <>
                                    {imageList.map((image, idx) => (
                                      <div key={idx} className="image-item">
                                        <img
                                          src={image["data_url"]}
                                          alt=""
                                          width="100"
                                        />
                                        <div className="image-item__btn-wrapper">
                                          <button
                                            type="button"
                                            onClick={() => onImageUpdate(idx)}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-cloud-plus"
                                              viewBox="0 0 16 16"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                                              />
                                              <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                            </svg>
                                          </button>
                                          <button
                                            type="button"
                                            onClick={() => onImageRemove(idx)}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-x"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                )}
                              </div>
                            )}
                          </ImageUploading>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : formInput.selType?.value === "video" ? (
                <div className="formInputBox formInputUploadBox">
                  <label htmlFor="video" className="formInputLabel">
                    video {!isEdit && <span className="required">*</span>}
                  </label>

                  <div
                    className={`commonWrapper commonUploadWrapper no-border`}
                  >
                    <div
                      className={`icon-upload-btn createIncentiveCategoryForImageUpload ${
                        formErrors.fieldErrors?.[index]?.video
                          ? "formError"
                          : ""
                      }`}
                    >
                      <div className="icon">
                        {loading ? (
                          <Loader />
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="49"
                            height="49"
                            viewBox="0 0 49 49"
                            fill="none"
                          >
                            <path
                              d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                              fill="#A5A5A5"
                            />
                            <path
                              d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                              fill="#A5A5A5"
                            />
                          </svg>
                        )}
                      </div>
                      <div className="image video">
                        <CustomizedDropzon
                          message={"Drag & drop video files here"}
                          onDrop={(acceptedFiles) =>
                            handleVideoDrop(acceptedFiles, index)
                          }
                          clearVideo={() =>
                            setFormImages((prevImages) => {
                              const newImages = [...prevImages];
                              newImages[index].video = [];
                              return newImages;
                            })
                          }
                        />
                      </div>

                      {isEdit &&
                      rowData?.video &&
                      formImages[index].video?.length === 0 ? (
                        <span className="previous-link with-video">
                          <video width="200" height="180" controls>
                            <source src={rowData.video}></source>
                          </video>
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}

              {formInput.selType?.value === "video" && (
                <div className="formInputBox">
                  <label htmlFor="description" className="formInputLabel">
                    Description
                  </label>

                  <textarea
                    name="description"
                    className={`formInput ${
                      formErrors?.description && "formError"
                    }`}
                    placeholder="Enter Description"
                    value={formValues.description}
                    onChange={(e) => onChangeInput(e, index)}
                  ></textarea>
                </div>
              )}
            </div>

            {formImages[index].frames?.length > 0 && (
              <div className="selected-video-snapshots mt30 frameSelection">
                <p>
                  Select a frame for the thumbnail{"  "}
                  <span className="required">*</span>
                </p>
                <div className="framesContainer">
                  {formImages[index].frames.map((frame, idx) => (
                    <div
                      className={`frame-img ${
                        formErrors?.fieldErrors?.[index]?.thumbnail
                          ? "formError"
                          : ""
                      }`}
                    >
                      <img
                        key={idx}
                        src={frame}
                        alt={`Frame ${idx}`}
                        onClick={() => handleThumbnailSelect(frame, index)}
                        className={`frame ${
                          frame === formImages[index].thumbnail
                            ? "selected"
                            : ""
                        }`}
                      />

                      {frame === formImages[index].thumbnail && (
                        <div className="selected-frame">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-check2-circle"
                            viewBox="0 0 16 16"
                          >
                            <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
                            <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                          </svg>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="formInputsGrid switchInputs">
              <div className="formInputBox formInputSwitchBox">
                <div
                  className={`commonWrapper commonSwitchWrapper no-border ${
                    formErrors?.isActive ? "formError" : ""
                  }`}
                >
                  <Form.Check
                    type="switch"
                    name="isActive"
                    label={`${formInput.isActive ? "Active" : "Not Active"}`}
                    checked={formInput.isActive}
                    onChange={(e) => onChangeInput(e, index)}
                  />
                </div>
              </div>
            </div>

            <div className="grayLine span2"></div>
          </React.Fragment>
        ))}

        {!isEdit ? (
          <div className="formInputBox span2">
            <div className="add-remove-btns">
              {formValues.length !== 1 ? (
                <button
                  type="button"
                  className="btn-action remove"
                  onClick={() => removeForm(formValues.length - 1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-dash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
                  </svg>
                  Remove
                </button>
              ) : null}

              <button
                type="button"
                className="btn-action add"
                onClick={addForm}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                </svg>
                Add More
              </button>
            </div>
          </div>
        ) : null}
      </form>
    </div>
  );
};

export default TestimonialForm;
